/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'icon-pause': {
    width: 18,
    height: 18,
    viewBox: '0 0 18 18',
    data: '<path pid="0" d="M4.857 14.85l1.667-.007c.46-.002.833-.043.83-.503L7.313 3.673c-.002-.46-.375-.498-.835-.496l-1.667.006c-.46.002-.833.044-.831.504l.043 10.666c.001.46.374.499.835.497zm6.667-.027l1.666-.007c.46-.001.833-.043.831-.503l-.043-10.666c-.001-.46-.374-.499-.835-.497l-1.666.007c-.461.002-.834.043-.832.503l.043 10.667c.002.46.375.498.835.496z" _fill="#fff"/>'
  }
})
